import { getHotArticles, getLatestArticles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';
import SectionTitle from '@/components/base/SectionTitle';

export default function HotRanking() {
  const hotArticles = getHotArticles(5);
  const latestArticles = getLatestArticles(5);

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            <SectionTitle
              title="热搜榜单"
              subtitle="全网最热吃瓜内容实时排行"
            />
            <div className="space-y-1">
              {hotArticles.map((article, index) => (
                <ArticleCard
                  key={article.id}
                  article={article}
                  variant="horizontal"
                />
              ))}
            </div>
          </div>

          <div>
            <SectionTitle
              title="最新发布"
              subtitle="刚刚更新的新鲜瓜"
            />
            <div className="bg-background-100 rounded-xl p-4 border border-background-200/70">
              {latestArticles.map((article, index) => (
                <ArticleCard
                  key={article.id}
                  article={article}
                  variant="compact"
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}